import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import qboIcon from '~/assets/public/qbo-icon.png';
import { BackLink, Icon, Page, Tooltip } from '~/components';
import { useApi, useIntegrations, useWorkspace } from '~/contexts';
import QBOSettingsPage from './QBOSettingsPage';
import { colors } from '~/styles';

const QBOLogo = styled.img`
  width: 2.875rem;
  height: 2.875rem;
  max-width: unset;
`;

const PageTitle = styled(Page.Title)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export default function QBOSettingsArea() {
  const { qboConnectionId } = useParams();
  const { workspace } = useWorkspace();
  const { qbo } = useIntegrations();
  const api = useApi();
  const [qboConnection, setQboConnection] = useState({ data: null, isReady: false });

  const fetchQboConnection = useCallback(async () => {
    if (!qboConnectionId) return;
    try {
      const { data } = await api.www.workspaces(workspace.id).qbo(qboConnectionId).getStatus();
      setQboConnection({ data, isReady: true });
    } catch {
      setQboConnection({ data: null, isReady: true });
    }
  }, [api, qboConnectionId, workspace.id]);

  useEffect(() => {
    fetchQboConnection();
  }, [fetchQboConnection]);

  if (!qbo) return null;

  return (
    <Page>
      <Page.Header>
        <BackLink defaultPath={`/app/${workspace.key}/settings/integrations`} ignoreHistory />

        <Page.Info>
          <Page.Eyebrow>Settings</Page.Eyebrow>
          <PageTitle>
            {qboConnection.isReady ? (
              <>
                {qboConnection.data?.name ?? 'QuickBooks Online'}
                {qboConnection.data?.status !== 'ok' && (
                  <Tooltip message={qboConnection.data?.message}>
                    <Icon icon="warning" color={colors.warning} />
                  </Tooltip>
                )}
              </>
            ) : (
              'QuickBooks Online'
            )}
          </PageTitle>
        </Page.Info>

        <Page.Actions>
          <QBOLogo src={qboIcon} />
        </Page.Actions>
      </Page.Header>

      <QBOSettingsPage />
    </Page>
  );
}
